import produce from 'immer';

import type { Action } from 'Lib/reduxType';
import { milliseconds as perfTimer } from 'Lib/utils/perfTimer';

import {
  APP_SESSION_STARTED,
  SESSION_ACTIVITY,
  SESSION_TIMEOUT,
  USER_SESSION_STARTED,
} from './constants';
import initialState from './initialState';
import type { SessionState } from './types';

export const reducer = produce<SessionState, [Action]>((draft, action) => {
  switch (action.type) {
    case APP_SESSION_STARTED: {
      const {
        perfTime: appTimerStart = perfTimer(),
        sessionId,
        time = Date.now(),
      } = action.payload;

      draft.appSessionId = sessionId;
      draft.appSessionStart = time;
      draft.appSessionStartPerfTime = appTimerStart; // TODO: change to perfTime or sessionTime?
      draft.isExpired = false;
      draft.lastActivity = time;
      draft.lastActivityPerfTime = appTimerStart;

      break;
    }

    case USER_SESSION_STARTED: {
      const {
        perfTime: userTimerStart = perfTimer(),
        sessionId,
        time = Date.now(),
      } = action.payload;

      draft.userSessionId = sessionId;
      draft.userSessionStart = time;
      draft.userSessionStartPerfTime = userTimerStart;
      draft.isExpired = false;
      draft.lastActivity = time;

      break;
    }

    case SESSION_ACTIVITY: {
      const { perfTime: timer = perfTimer(), time = Date.now() } = action.payload;

      draft.lastActivity = time;
      draft.lastActivityPerfTime = timer;

      break;
    }

    case SESSION_TIMEOUT: {
      draft.isExpired = true;
      break;
    }
    default:
      break;
  }
}, initialState);

export const persistConfig = {
  wait: 100,
};
